const featureCategories = [
  {
    title: "Kitchen",
    icon: "kitchen",
    items: [
      { icon: "coffee", label: "Coffee Maker" },
      { icon: "breakfast_dining", label: "Toaster" },
      { icon: "microwave", label: "Microwave" },
      { icon: "local_fire_department", label: "Stove & Oven" },
      { icon: "kitchen", label: "Refrigerator & Freezer" },
      { icon: "restaurant", label: "Dishes & Utensils" },
      { icon: "done_all", label: "Fully Equipped" },
    ],
  },
  {
    title: "Comfort & Safety",
    icon: "shield",
    items: [
      { icon: "ac_unit", label: "Air Conditioning" },
      { icon: "air", label: "Ceiling Fans" },
      { icon: "bed", label: "Quality Linens" },
      { icon: "checkroom", label: "Clothes Hangers" },
      { icon: "dry_cleaning", label: "Shampoo & Hairdryer" },
      { icon: "iron", label: "Ironing Board" },
      { icon: "lock", label: "Safe" },
    ],
  },
  {
    title: "Entertainment",
    icon: "sports_esports",
    items: [
      { icon: "tv", label: "TV" },
      { icon: "sports_tennis", label: "Table Tennis" },
      { icon: "sports_soccer", label: "Foosball" },
      { icon: "toys", label: "Games & Toys" },
      { icon: "park", label: "Tire Swing" },
      { icon: "kayaking", label: "7 Kayaks" },
      { icon: "sports_soccer", label: "Football" },
    ],
  },
  {
    title: "Internet & Business",
    icon: "wifi",
    items: [
      { icon: "wifi", label: "High-Speed WiFi" },
      { icon: "speed", label: "100 Mbps Fiber Optics" },
      { icon: "laptop", label: "Laptop-Friendly Workspace" },
      { icon: "desktop_mac", label: "Desktop Computer" },
    ],
  },
  {
    title: "Location",
    icon: "place",
    items: [
      { icon: "water", label: "Ocean / Water View" },
      { icon: "beach_access", label: "Beachfront" },
      { icon: "lock", label: "Private Property" },
      { icon: "yard", label: "Garden" },
    ],
  },
  {
    title: "Safety",
    icon: "health_and_safety",
    items: [
      { icon: "medical_services", label: "First Aid Kit" },
      { icon: "smoke_free", label: "Smoke Detector" },
      { icon: "co2", label: "CO Detector" },
      { icon: "fire_extinguisher", label: "Fire Extinguisher" },
    ],
  },
  {
    title: "Laundry",
    icon: "local_laundry_service",
    items: [
      { icon: "local_laundry_service", label: "Washing Machine" },
      { icon: "dry", label: "Tumble Dryer" },
    ],
  },
  {
    title: "Outdoor & Cooking",
    icon: "outdoor_grill",
    items: [
      { icon: "outdoor_grill", label: "BBQ Grill" },
      { icon: "fireplace", label: "Fire Pit Area" },
    ],
  },
  {
    title: "Pool & Wellness",
    icon: "pool",
    items: [
      { icon: "pool", label: "Private Pool" },
      { icon: "hot_tub", label: "Jacuzzi / Hot Tub" },
    ],
  },
];

// Total count of all individual amenities
export const totalAmenityCount = featureCategories.reduce((sum, cat) => sum + cat.items.length, 0);

// Top highlights for homepage preview
export const highlightAmenities = [
  { icon: "beach_access", label: "Beachfront" },
  { icon: "pool", label: "Private Pool" },
  { icon: "hot_tub", label: "Jacuzzi / Hot Tub" },
  { icon: "kayaking", label: "7 Kayaks" },
  { icon: "ac_unit", label: "Air Conditioning" },
  { icon: "wifi", label: "100 Mbps WiFi" },
  { icon: "kitchen", label: "Full Kitchen" },
  { icon: "local_laundry_service", label: "Washer & Dryer" },
  { icon: "outdoor_grill", label: "BBQ Grill" },
  { icon: "sports_tennis", label: "Table Tennis" },
  { icon: "sports_soccer", label: "Foosball" },
  { icon: "tv", label: "TV" },
];

export default featureCategories;
